const periodSelector = `common.periodSelector`;

export default {
    periodSelector: {
        input: `${periodSelector}.inputNumberOfPeriods`,
        select: `${periodSelector}.selectPeriod`,
        disabledSelector: `${periodSelector}.disabledSelector`,
        switch: `${periodSelector}.switch`,
        template: `${periodSelector}.template`,
        openPeriod: `${periodSelector}.openPeriodSelector`,
        rollingAndFixed: `${periodSelector}.rollingAndFixedFieldGroup`,
    },
};
